/**
 * The discharge letter a GP chooses in the notes form. The values are the backend's template
 * indices (SendConsultationToGPTemplatesKeys), so they must not be renumbered.
 *
 * The fourth letter - the prescription notification - is not a choice: the backend uses it
 * whenever a prescription was issued, whatever is picked here.
 */
export const GP_LETTER_TYPES = [
    { value: 0, label: 'Information only' },
    { value: 1, label: 'Action required' },
    { value: 2, label: 'Urgent action required' },
];

export const gpLetterTypeLabel = value => {
    const match = GP_LETTER_TYPES.find(type => type.value === value);
    return match ? match.label : null;
};
